<template>
  <div class="dropdown nav-item">
    <a href="javascript:;" id="ddlNotif" data-bs-toggle="dropdown" aria-expanded="false"
       class="btn btn-icon-only nav-link position-relative" @click="abrir">
      <!-- sino -->
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="feather feather-bell">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
      <span v-if="naoLidas > 0" class="badge badge-danger counter">{{ naoLidas > 99 ? '99+' : naoLidas }}</span>
    </a>

    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddlNotif"
        style="min-width: 320px; max-width: 360px;">
      <li class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
        <span class="d-flex align-items-center gap-2"><strong>Notificações</strong><AjudaBotao :slug="AJUDA_SLUGS.SISTEMA_NOTIFICACOES" variante="popup" titulo="Ajuda: notificações" /></span>
        <a v-if="naoLidas > 0" href="javascript:;" class="small text-primary" @click.stop="lerTodas">
          Marcar todas como lidas
        </a>
      </li>

      <li v-if="loading" class="px-3 py-3 text-center text-muted">Carregando…</li>
      <li v-else-if="!itens.length" class="px-3 py-3 text-center text-muted">Nenhuma notificação.</li>

      <li v-for="n in itens" :key="n.id">
        <a href="javascript:;" class="dropdown-item d-flex flex-column align-items-start py-2"
           :class="{ 'bg-light': !n.lida }" @click.stop="abrirNotif(n)">
          <div class="d-flex w-100 justify-content-between">
            <span class="fw-bold text-truncate" style="max-width: 230px;">{{ n.titulo }}</span>
            <small class="text-muted ms-2">{{ formatData(n.dataCriacao) }}</small>
          </div>
          <small class="text-muted text-wrap">{{ n.mensagem }}</small>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import AjudaBotao from '@/components/AjudaBotao.vue';
import { AJUDA_SLUGS } from '@/config/ajudaEngage';
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { listaNotificacoes, contarNaoLidas, marcarLida, marcarTodasLidas } from '@/stores/notificacoesStore';

const router = useRouter();
const itens = ref([]);
const naoLidas = ref(0);
const loading = ref(false);
let pollInterval = null;

const formatData = (dt) => {
  if (!dt) return '';
  try {
    return new Date(dt).toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
    });
  } catch { return ''; }
};

const atualizaContador = async () => {
  const json = await contarNaoLidas();
  if (json.ok) naoLidas.value = Number(json.data) || 0;
};

const abrir = async () => {
  loading.value = true;
  const json = await listaNotificacoes(30);
  if (json.ok) itens.value = json.data || [];
  loading.value = false;
};

const abrirNotif = async (n) => {
  if (!n.lida) {
    await marcarLida(n.id);
    n.lida = true;
    if (naoLidas.value > 0) naoLidas.value--;
  }
  if (n.route) router.push(n.route).catch(() => {});
};

const lerTodas = async () => {
  await marcarTodasLidas();
  itens.value.forEach(n => { n.lida = true; });
  naoLidas.value = 0;
};

onMounted(() => {
  atualizaContador();
  // Atualiza o badge periodicamente (a chegada real-time fica para SignalR no futuro).
  pollInterval = setInterval(atualizaContador, 60_000);
});

onUnmounted(() => {
  if (pollInterval) clearInterval(pollInterval);
});
</script>
